import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const CostBreakdownSection = ({ formData, handleInputChange, errors }) => {
  const costCategories = [
    { key: 'rawMaterialCost', label: 'Biaya Bahan Baku (Susu)', icon: 'Milk' },
    { key: 'packagingCost', label: 'Biaya Kemasan', icon: 'Package' },
    { key: 'laborCost', label: 'Biaya Tenaga Kerja', icon: 'Users' },
    { key: 'utilityCost', label: 'Biaya Utilitas (Listrik, Air)', icon: 'Zap' },
    { key: 'transportationCost', label: 'Biaya Transportasi', icon: 'Truck' },
    { key: 'maintenanceCost', label: 'Biaya Pemeliharaan', icon: 'Wrench' },
    { key: 'marketingCost', label: 'Biaya Pemasaran', icon: 'Megaphone' },
    { key: 'administrativeCost', label: 'Biaya Administrasi', icon: 'FileText' },
    { key: 'otherOperationalCost', label: 'Biaya Operasional Lainnya', icon: 'MoreHorizontal' }
  ];

  const calculateTotalCost = () => {
    let total = 0;
    costCategories?.forEach(category => {
      const value = parseFloat(formData?.[category?.key]) || 0;
      total += value;
    });
    return total?.toFixed(0);
  };

  const calculateCostPercentage = (cost) => {
    let total = parseFloat(calculateTotalCost());
    if (total === 0) return 0;
    return ((parseFloat(cost) || 0) / total * 100)?.toFixed(1);
  };

  return (
    <div className="card">
      <div className="flex items-start gap-4 mb-6">
        <div className="w-12 h-12 rounded-xl bg-warning/10 flex items-center justify-center flex-shrink-0">
          <Icon name="DollarSign" size={24} color="var(--color-warning)" />
        </div>
        <div className="flex-1">
          <h2 className="text-2xl md:text-3xl font-semibold mb-2">Rincian Biaya Operasional</h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Detail biaya operasional bulanan untuk analisis margin dan efisiensi
          </p>
        </div>
      </div>
      <div className="space-y-4 md:space-y-6">
        {costCategories?.map((category) => (
          <div key={category?.key} className="p-4 md:p-6 bg-muted rounded-lg">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-card flex items-center justify-center">
                <Icon name={category?.icon} size={20} color="var(--color-foreground)" />
              </div>
              <h3 className="text-base md:text-lg font-medium flex-1">{category?.label}</h3>
              <span className="text-sm font-medium text-muted-foreground data-text">
                {calculateCostPercentage(formData?.[category?.key])}%
              </span>
            </div>
            <Input
              type="number"
              placeholder="Masukkan biaya bulanan"
              value={formData?.[category?.key] || ''}
              onChange={(e) => handleInputChange(category?.key, null, e?.target?.value)}
              error={errors?.[category?.key]}
              className="w-full"
            />
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 md:p-6 bg-warning/10 rounded-lg border-2 border-warning/20">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Total Biaya Operasional Bulanan</p>
            <p className="text-2xl md:text-3xl font-bold data-text">
              Rp {parseFloat(calculateTotalCost())?.toLocaleString('id-ID')}
            </p>
          </div>
          <div className="w-12 h-12 rounded-xl bg-warning/20 flex items-center justify-center">
            <Icon name="Calculator" size={24} color="var(--color-warning)" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CostBreakdownSection;